export default __webpack_public_path__ + "static/media/speak.ab8205e8.svg";